export default __webpack_public_path__ + "static/OpenSansLight-ea99d193b254a33efb769817b9a0042a.eot";